module.exports = __webpack_public_path__ + "media/images/logo_text_pl-1c1d7fe2618117120ec9bb87f5facdc0.svg";